export const statusOptions = [
  ["waiting_to_submit", "Waiting to Submit"],
  ["submitted", "Sent / Waiting for Approval"],
  ["approved", "Approved"],
];

export const today = () => new Date().toISOString().slice(0, 10);
